import { Component, OnInit, ContentChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CourseCardPresentationComponent } from 'app/core/components/workflow-new/course/course-card-presentation/course-card-presentation.component';
import { CardPresentationComponent } from 'app/core/components/workflow-new/common/card-presentation';
import { RxComponent } from 'app/shared/components/common/rx.component';

@Component({
  selector: 'itpx-clickable-wrapper-container',
  templateUrl: './clickable-wrapper-container.component.html',
  styleUrls: ['../style.css']
})
export class ClickableWrapperContainerComponent extends RxComponent {
  @Output() stateChange$ = new EventEmitter<string>();
  @ContentChild(CardPresentationComponent) card: CardPresentationComponent;
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {super(); }

  /*
   * class identifier 'link' is defined in inner-course-card.component.html
   * we also check one level up in DOM hierarchy in case the user clicks on the image of the anchor
   */
  onClick(event: any) {
    if (!event.target.classList.contains('link') && !event.target.parentElement.classList.contains('link')) {
      if (this.card.conf.target) {
        this.router.navigate(this.card.conf.target, { relativeTo: this.route });
      } else if (this.card.conf.observableAction) {
        this.stateChange$.emit('loading');
        this.card.conf.observableAction.bindToLifecycle(this).subscribe(res =>
          {this.router.navigate(this.card.conf.target, { relativeTo: this.route })},
          err => {this.stateChange$.emit('ready')}
        );
      } else {
        window.open(this.card.conf.links[0].url.join('/'), '_blank', 'noopener,noreferrer');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/common/clickable-wrapper-container/clickable-wrapper-container.component.ts